import React, { useState } from "react";
import axios from "axios";
import * as XLSX from "xlsx";
import { getToken, base_url } from "../../config/config";

const AddLieferant = () => {
  const [formData, setFormData] = useState({
    konto: "",
    bezeichnung: "",
    kurzbezeichnung: "",
    ustIdNummer: "",
    address: "",
    plz: "",
    ort: "",
    telefon: "",
    email: "",
  });

  const [file, setFile] = useState(null);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const handleFileChange = (e) => {
    setFile(e.target.files[0]);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      await axios.post(`${base_url}/v1/addLieferant`, formData);
      alert("Lieferant added successfully!");
      setFormData({
        konto: "",
        bezeichnung: "",
        kurzbezeichnung: "",
        ustIdNummer: "",
        address: "",
        plz: "",
        ort: "",
        telefon: "",
        email: "",
      });
    } catch (error) {
      alert(
        "Error adding Lieferant: " +
          (error.response?.data?.message || "Unknown error"),
      );
    }
  };

  const handleBulkUpload = async () => {
    if (!file) {
      alert("Please select a file first.");
      return;
    }

    const reader = new FileReader();
    reader.onload = async (event) => {
      const data = new Uint8Array(event.target.result);
      const workbook = XLSX.read(data, { type: "array" });
      const worksheet = workbook.Sheets[workbook.SheetNames[0]];
      const jsonData = XLSX.utils.sheet_to_json(worksheet);

      const validData = jsonData.map((entry) => ({
        konto: entry.Konto || "",
        bezeichnung: entry.Bezeichnung || "",
        kurzbezeichnung: entry.Kurzbezeichnung || "",
        ustIdNummer: entry.UStIDNummer || "",
        address: entry.Adresse || "",
        plz: entry.PLZ || "",
        ort: entry.Ort || "",
      }));

      try {
        await axios.post(`${base_url}/v1/addLieferant`, validData);
        alert("Bulk upload successful!");
        setFile(null);
      } catch (error) {
        console.error("Bulk upload error:", error.response || error);
        alert(
          "Error uploading bulk data: " +
            (error.response?.data?.message || "Unknown error"),
        );
      }
    };
    reader.readAsArrayBuffer(file);
  };

  return (
    <div
      style={{
        maxWidth: "600px",
        margin: "0 auto",
        padding: "20px",
        border: "1px solid #ccc",
        borderRadius: "8px",
        boxShadow: "0 0 10px rgba(0, 0, 0, 0.1)",
        backgroundColor: "#f9f9f9",
      }}>
      <h1 style={{ textAlign: "center" }}>Add Lieferant</h1>
      <form
        onSubmit={handleSubmit}
        style={{ display: "flex", flexDirection: "column", gap: "15px" }}>
        <label>
          <strong>Konto:</strong>
        </label>
        <input
          type='text'
          name='konto'
          value={formData.konto}
          onChange={handleInputChange}
          required
        />

        <label>
          <strong>Bezeichnung:</strong>
        </label>
        <input
          type='text'
          name='bezeichnung'
          value={formData.bezeichnung}
          onChange={handleInputChange}
          required
        />

        <label>
          <strong>Kurzbezeichnung:</strong>
        </label>
        <input
          type='text'
          name='kurzbezeichnung'
          value={formData.kurzbezeichnung}
          onChange={handleInputChange}
          required
        />

        <label>
          <strong>USt-IdNr:</strong>
        </label>
        <input
          type='text'
          name='ustIdNummer'
          value={formData.ustIdNummer}
          onChange={handleInputChange}
          required
        />

        <label>
          <strong>Telefon:</strong>
        </label>
        <input
          type='text'
          name='telefon'
          value={formData.telefon}
          onChange={handleInputChange}
          required
        />

        <label>
          <strong>Email:</strong>
        </label>
        <input
          type='text'
          name='email'
          value={formData.email}
          onChange={handleInputChange}
          required
        />

        <label>
          <strong>Address:</strong>
        </label>
        <input
          type='text'
          name='address'
          value={formData.address}
          onChange={handleInputChange}
          required
        />

        <label>
          <strong>PLZ:</strong>
        </label>
        <input
          type='text'
          name='plz'
          value={formData.plz}
          onChange={handleInputChange}
          required
        />

        <label>
          <strong>Ort:</strong>
        </label>
        <input
          type='text'
          name='ort'
          value={formData.ort}
          onChange={handleInputChange}
          required
        />

        <button
          type='submit'
          style={{
            backgroundColor: "#007bff",
            color: "white",
            padding: "10px",
            cursor: "pointer",
          }}>
          Add Lieferant
        </button>
      </form>

      <h2 style={{ textAlign: "center" }}>Bulk Upload</h2>
      <input type='file' accept='.xlsx, .xls' onChange={handleFileChange} />
      <button
        onClick={handleBulkUpload}
        style={{
          backgroundColor: "#28a745",
          color: "white",
          padding: "10px",
          cursor: "pointer",
        }}>
        Upload
      </button>
    </div>
  );
};

export default AddLieferant;
